<template>
    <div style="width: 100%;" v-if="showView">
        <div
            class="storyscale_spotlight_modal show animated faster"
            :class="[ $props.depTyp === 'embed' ? animationClass : `${ animationClass } storyscale_ss_modal` ]"
            v-if="showModal"
        >
            <div
                class="storyscale_ss_modal_dialog storyscale_ss_small_modal_dialog"
                :style="[ $props.depTyp === 'embed' ? { maxWidth: `100% !important`, margin: 0 } : {} ]"
            >
                <div
                    class="storyscale_ss_modal_content"
                    :style="[ $props.depTyp === 'embed' ? { marginTop: 0, padding: 0 } : { marginTop: `-2%` } ]"
                >
                    <button type="button" class="storyscale_ss_close" @click.prevent="closeModal" v-if="$props.depTyp !== 'embed'">
                        <span aria-hidden="true" >&times;</span>
                    </button>
                    <div class="storyscale_ss_modal_body">
                        <div class="storyscale_image-modal">
<!--                            <img class="img-fluid" :src="nowViewing.asset_url" alt="modal-image" v-if="nowViewing.asset_type_id === 4">-->
                            <div style="width: 100%; height: 100%; background: #ffffff7a; display: flex; align-items: center; justify-content: center;" v-show="loading">
                                <img
                                    src="https://asset.storyscale.com/Ripple-1.7s-200px.gif"
                                    style="width: 80px; height: 80px;"
                                    alt="Loading..."
                                    class="loading-key"
                                />
                            </div>
                            <div  style="width: 100%; height: 100%;" id="viewerContainer">
                                <!-- <div
                                    style="width: 100%;
                                    height: 100%;
                                    overflow-y: scroll;"
                                    v-if="nowViewing.asset_type_id === 4"
                                >
                                    <img
                                        style="height: auto;"
                                        :src="nowViewing.asset_url"
                                        alt=""
                                    />
                                </div>
                                <video-player v-if="nowViewing.asset_type_id === 6"
                                    style="max-height: 100px !important;"
                                    ref="videoPlayer"
                                    :options="playerOptions"
                                    :playsinline="true"
                                    customEventName="customstatechangedeventname">
                                </video-player>
                                <iframe
                                    width="100%" height="100%"
                                    class="iframe-asset-holder"
                                    style="width: 100%;
                                    height: 100%;
                                    overflow-y: scroll;"
                                    :src="nowViewing.asset_url ? `${nowViewing.asset_url}#toolbar=0&navpanes=0&scrollbar=0` : `https://securnyx360.s3.ap-south-1.amazonaws.com/lazy_logo.png`"
                                    v-if="nowViewing.asset_type_id === 1 || nowViewing.asset_type_id === 5 || nowViewing.asset_type_id === 5"
                                ></iframe>
                                <iframe
                                    width="100%" height="100%"
                                    class="iframe-asset-holder"
                                    style="width: 100%;
                                    height: 100%;
                                    overflow-y: scroll;"
                                    :src="nowViewing.asset_url ? `https://view.officeapps.live.com/op/embed.aspx?src=${ nowViewing.asset_url }` : `https://securnyx360.s3.ap-south-1.amazonaws.com/lazy_logo.png`"
                                    v-if="nowViewing.asset_type_id === 3"
                                ></iframe> -->
                                <div
                                    style="width: 100%;
                                    height: 100%;
                                    overflow-y: scroll;
                                    align-items: center; justify-content: center; background: #cfd3e0;"
                                    v-if="init && ( this.dataObj.launch_with_splash || this.dataObj.launch_with_splash === 1 )"
                                >
                                    <img
                                        style="width: 100%; height: auto;"
                                        :src="dataObj.splash_asset_id.asset_url"
                                        alt=""
                                    />
                                </div>

                                <div
                                    style="width: 100%;
                                    height: 100%;
                                    overflow-y: hidden; display: flex;
                                    align-items: center; justify-content: center; background: #cfd3e0;"
                                    v-show="nowViewing.asset_type_id === 4 && !loading && !init"
                                >
                                    <img
                                        style="width: 100%;"
                                        :src="nowViewing.asset_url"
                                        alt=""
                                    />
                                </div>
<!--                                        VIDEO-->
                                <video-player v-show="nowViewing.asset_type_id === 6 && !loading && !init"
                                    style="
                                    max-height: 626px !important; width: 100%;"
                                    ref="videoPlayer"
                                    :options="playerOptions"
                                    :playsinline="true"
                                    customEventName="customstatechangedeventname">
                                </video-player>
<!--                                        PDF-->
                                <div
                                    id="pdfContainer"
                                    style="width: 100%; height: 100%; text-align: center"
                                    v-show="nowViewing.asset_type_id === 1 && !loading && !init"
                                >
                                    <div
                                        ref="progressBar"
                                        style="
                                        height: 6px;
                                        width:0;
                                        border-radius: 0 5px 5px 0;"
                                        :style="[
                                            dataObj.style_guide_id ?
                                            {
                                                background: dataObj.style_guide_id.primary_accent_color,
                                            } : {
                                                background: `#4b60eb`,
                                            }
                                        ]"
                                    ></div>
                                    <div
                                        id="pdfViewer"
                                        style="width: 100%; height: 100%;"
                                        :style="[ { overflowX: `auto`, overflowY: `scroll` } ]"
                                        @scroll="handleScroll"
                                        ref="pdfViewer"
                                    ></div>
                                </div>
<!--                                        WEBSITE AND YOUTUBE-->
                                <iframe
                                    width="100%" height="100%"
                                    class="iframe-asset-holder" id="pdfIframe"
                                    oncontextmenu="return false"
                                    style="width: 100%;
                                    overflow-y: scroll;"
                                    :src="nowViewing.asset_url && nowViewing.asset_type_id !== 3 ? `${nowViewing.asset_url}#toolbar=0&navpanes=0&scrollbar=0` : `https://securnyx360.s3.ap-south-1.amazonaws.com/lazy_logo.png`"
                                    v-show="!nowViewing.readability_enabled && (nowViewing.asset_type_id === 5 || nowViewing.asset_type_id === 7 && !loading && !init)"
                                ></iframe>

                                 <readable-iframe
                                    width="100%" height="100%"
                                    class="iframe-asset-holder" id="pdfIframe2"
                                    oncontextmenu="return false"
                                    style="width: 100%;overflow-y: auto;max-height: 98%;"
                                    :src="nowViewing.asset_url"
                                    v-show="(nowViewing.asset_type_id === 5 && nowViewing.readability_enabled)  && !loading && !init"
                                ></readable-iframe>

<!--                                        DOC FILE-->
                                <iframe
                                    width="100%" height="100%"
                                    class="iframe-asset-holder"
                                    style="width: 100%;
                                    height: 100%;
                                    overflow-y: scroll;"
                                    :src="nowViewing.asset_url ? `https://view.officeapps.live.com/op/embed.aspx?src=${ nowViewing.asset_url }` : `https://securnyx360.s3.ap-south-1.amazonaws.com/lazy_logo.png`"
                                    v-show="nowViewing.asset_type_id === 3 && !loading && !init"
                                ></iframe>

                                <div
                                    class="animated bounceIn faster"
                                    style="position: absolute;
                                        background: #fff;
                                        border-radius: 4px;
                                        top: 38px; color: #141945;
                                        left: 30px; font-size: 14px;
                                        padding: 10px 18px;"
                                    :style="[
                                        dataObj.style_guide_id ?
                                        {
                                            fontFamily: dataObj.style_guide_id.font.toLocaleString(),
                                        } : {}
                                    ]"
                                    v-if="showTimer"
                                >
                                    <span
                                        style="font-weight: 700; font-size: 23px;"
                                        :style="[
                                        dataObj.style_guide_id ?
                                        {
                                            color: dataObj.style_guide_id.primary_accent_color,
                                        } : {
                                            color: `#4b60eb`,
                                        }
                                    ]"
                                    >
                                        {{ secondsCounter - 1 }}
                                    </span>
                                    <span style="position: relative; top: -4px;">
                                        Loading
                                        {{ Math.round(progress * 100) === 0 || Math.round(progress * 100) <= 30? 'Previous' : '' }}
                                        {{ Math.round(progress * 100) === 100 || Math.round(progress * 100) >= 80 ? 'Next' : '' }}
                                        Asset
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="storyscale_list-holder">
                            <ul>
                                <li
                                    v-if="primarySeq && primarySeq.assets.length >= 1"
                                    v-for="( lib, i ) in primarySeq.assets"
                                    :key="i"
                                    @click.prevent="showContent(lib, i, true)"
                                    style="cursor: pointer;"
                                >
                                    <img
                                        :src="lib.cover_image_url"
                                        :alt="lib.asset_friendly_name"
                                        style="margin-right: 15px; width: 75px; min-width: 75px; border-radius: 5px; max-height: 55px; height: 55px; border: 2px solid #e4e6f1;"
                                        v-if="!dataObj.show_icon"
                                    />
                                    <div class="storyscale_svg-holder" v-if="dataObj.show_icon">
                                        <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="lib.asset_type_id === 1">
                                            <rect width="40" height="40" rx="4" fill="#F6F8FC"/>
                                            <path d="M19.3778 16.9778C19.4667 16.9778 19.4667 16.9778 19.3778 16.9778C19.4667 16.6222 19.5556 16.4444 19.5556 16.1778V16C19.6444 15.5556 19.6444 15.2 19.5556 15.1111C19.5556 15.1111 19.5556 15.1111 19.5556 15.0222L19.4667 14.9333C19.4667 14.9333 19.4667 15.0222 19.3778 15.0222C19.2 15.5556 19.2 16.1778 19.3778 16.9778ZM16.7111 23.1111C16.5333 23.2 16.3556 23.2889 16.2667 23.3778C15.6444 23.9111 15.2 24.5333 15.1111 24.8C15.6444 24.7111 16.1778 24.1778 16.7111 23.1111C16.8 23.1111 16.8 23.1111 16.7111 23.1111C16.7111 23.1111 16.8 23.1111 16.7111 23.1111ZM24.8889 21.7778C24.8 21.6889 24.4444 21.4222 23.2 21.4222C23.1111 21.4222 23.1111 21.4222 23.0222 21.4222C23.0222 21.4222 23.0222 21.4222 23.0222 21.5111C23.6444 21.7778 24.2667 21.9556 24.7111 21.9556C24.8 21.9556 24.8 21.9556 24.8889 21.9556H24.9778C24.9778 21.9556 24.9778 21.9556 24.9778 21.8667C24.9778 21.8667 24.8889 21.8667 24.8889 21.7778ZM26.2222 12H13.7778C12.8 12 12 12.8 12 13.7778V26.2222C12 27.2 12.8 28 13.7778 28H26.2222C27.2 28 28 27.2 28 26.2222V13.7778C28 12.8 27.2 12 26.2222 12ZM25.2444 22.4889C25.0666 22.5778 24.8 22.6667 24.4444 22.6667C23.7333 22.6667 22.6667 22.4889 21.7778 22.0444C20.2667 22.2222 19.1111 22.4 18.2222 22.7555C18.1333 22.7555 18.1333 22.7555 18.0444 22.8444C16.9778 24.7111 16.0889 25.6 15.3778 25.6C15.2 25.6 15.1111 25.6 15.0222 25.5111L14.5778 25.2444V25.1556C14.4889 24.9777 14.4889 24.8889 14.4889 24.7111C14.5778 24.2667 15.1111 23.4667 16.1778 22.8444C16.3556 22.7555 16.6222 22.5778 16.9778 22.4C17.2444 21.9555 17.5111 21.4222 17.8667 20.8C18.3111 19.9111 18.5778 19.0222 18.8444 18.2222C18.4889 17.1556 18.3111 16.5333 18.6667 15.2889C18.7556 14.9333 19.0222 14.5778 19.3778 14.5778H19.5556C19.7333 14.5778 19.9111 14.6667 20.0889 14.7556C20.7111 15.3778 20.4444 16.8 20.0889 17.9556C20.0889 18.0444 20.0889 18.0444 20.0889 18.0444C20.4444 19.0222 20.9778 19.8222 21.5111 20.3556C21.7778 20.5333 21.9556 20.7111 22.3111 20.8889C22.7556 20.8889 23.1111 20.8 23.4667 20.8C24.5333 20.8 25.2444 20.9778 25.5111 21.4222C25.6 21.6 25.6 21.7778 25.6 21.9556C25.5111 22.0444 25.4222 22.3111 25.2444 22.4889ZM19.4667 19.0222C19.2889 19.6444 18.9333 20.3556 18.5778 21.1556C18.4 21.5111 18.2222 21.7778 18.0444 22.1333H18.1333H18.2222C19.3778 21.6889 20.4444 21.4222 21.1556 21.3333C20.9777 21.2444 20.8889 21.1556 20.8 21.0667C20.3556 20.5333 19.8222 19.8222 19.4667 19.0222Z" :fill="dataObj.style_guide_id.primary_accent_color"/>
                                        </svg>
                                        <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="lib.asset_type_id === 6 || lib.asset_type_id === 7">
                                            <rect width="40" height="40" rx="4" fill="#F6F8FC"/>
                                            <path d="M25.1229 18.5143L16.2355 12.43C15.8251 12.1488 15.4115 12 15.0678 12C14.4033 12 13.9922 12.5333 13.9922 13.4261V26.576C13.9922 27.4677 14.4028 28 15.0657 28C15.41 28 15.8169 27.8511 16.2283 27.5691L25.1198 21.485C25.6916 21.093 26.0083 20.5657 26.0083 19.9993C26.0084 19.4333 25.6954 18.906 25.1229 18.5143Z"  :fill="dataObj.style_guide_id.primary_accent_color"/>
                                        </svg>
                                        <svg :fill="dataObj.style_guide_id.primary_accent_color"
                                            width="48" height="48"
                                            viewBox="0 0 40 40"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            v-if="lib.asset_type_id === 2 || lib.asset_type_id === 3 || lib.asset_type_id === 4 || lib.asset_type_id === 5"
                                        >
                                            <rect width="40" height="40" rx="4" fill="#F6F8FC"/>
                                            <path d="M20.0003 18C18.1623 18 16.667 19.4953 16.667 21.3333C16.667 23.1713 18.1623 24.6667 20.0003 24.6667C21.8383 24.6667 23.3336 23.1713 23.3336 21.3333C23.3336 19.4953 21.8383 18 20.0003 18ZM18.1083 22.688C18.5483 22.4533 18.7737 22.0293 18.7737 21.604C18.7797 21.438 18.883 21.3333 19.017 21.3073C20.0457 21.0753 20.4343 20.04 20.137 19.0133C21.2576 19.0793 22.1603 19.9347 22.3036 21.0333C20.6743 20.56 19.493 22.262 20.2177 23.6447C19.321 23.7293 18.5697 23.3307 18.1083 22.688Z" :fill="dataObj.style_guide_id.primary_accent_color"/>
                                            <path d="M26 12.6667H14C12.8973 12.6667 12 13.5641 12 14.6667V25.3334C12 26.4361 12.8973 27.3334 14 27.3334H26C27.1027 27.3334 28 26.4361 28 25.3334V14.6667C28 13.5641 27.1027 12.6667 26 12.6667ZM26 26.0001H14C13.6327 26.0001 13.3333 25.7014 13.3333 25.3334V16.0001H26.6667V25.3334C26.6667 25.7014 26.3673 26.0001 26 26.0001Z" :fill="dataObj.style_guide_id.primary_accent_color"/>
                                        </svg>
                                    </div>
                                    <div class="storyscale_list-content">
                                        <h4 :style="[ nowViewing.id === lib.id ? { fontWeight: 700, fontFamily: dataObj.style_guide_id.font } : { fontFamily: dataObj.style_guide_id.font } ]">
                                            {{ lib.asset_friendly_name }}
                                        </h4>
                                        <p :style="[ nowViewing.id === lib.id ? { fontWeight: 700, fontFamily: dataObj.style_guide_id.font } : { fontFamily: dataObj.style_guide_id.font } ]" class="storyscale_para-app">
                                            {{ lib.asset_description === 'N/A' ? '' : lib.asset_description }}
                                        </p>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2C4.68629 2 2 4.68628 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68628 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z" fill="#6D87A6" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3.99739C8.55229 3.99739 9 4.44511 9 4.99739V7.99544C9 8.54772 8.55229 8.99544 8 8.99544C7.44772 8.99544 7 8.54772 7 7.99544V4.99739C7 4.44511 7.44772 3.99739 8 3.99739Z" fill="#6D87A6" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29266 7.28856C7.68306 6.89791 8.31622 6.8977 8.70688 7.2881L10.7069 9.2868C11.0975 9.67719 11.0977 10.3104 10.7073 10.701C10.3169 11.0917 9.68377 11.0919 9.29312 10.7015L7.29312 8.70277C6.90247 8.31238 6.90227 7.67921 7.29266 7.28856Z" fill="#6D87A6" />
                                        </svg>
                                        <span class="storyscale_text-normal" style="vertical-align: top;" :style="[ nowViewing.id === lib.id ? { fontWeight: 700, fontFamily: dataObj.style_guide_id.font } : { fontFamily: dataObj.style_guide_id.font } ]">
                                            {{ parseFloat(Number( lib.reading_time ) / 60).toFixed(2) }} minutes
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';
    import {videoPlayer} from "vue-video-player";
    import $ from 'jquery';
    import * as pdfjsLib from 'pdfjs-dist/build/pdf';
    import * as pdfjsViewer from 'pdfjs-dist/lib/web/pdf_viewer';
    import WebFont from 'webfontloader';
    import VueScriptComponent from 'vue-script-component'
    import AnalyticsTracking from "@/analytics";
    import BigPicture from "@/big-picture";
    import ReadableIframe from "@/components/readable-content/iframe";

    var _idleSecondsTimer = null;
    var _idleSecondsCounter = 0;


    export default {
        props: [ 'obj','showSequenceId','showAssetId','onClose', 'depTyp' ],
        components: {
            videoPlayer,
            VueScriptComponent,
            ReadableIframe,
        },
        created () {
            if ( this.$props.depTyp !== 'embed' ) {
                document.querySelector('html').style.overflow = 'hidden';
            }
            // Deep Link
            this.showSequence(this.showSequenceId);
            // Deep Link

            pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

            this.primarySeq = this.dataObj.primary_sequence;
            this.primarySeq.assets = this.primarySeq.assets.map( ( lib ) => {
                lib.now = false;
                return lib;
            } );
            this.primarySeq.assets[ 0 ].now = true;
            this.nowViewing = this.primarySeq.assets[ 0 ];

            // Deep link
            if(this.showAssetId && !this.linkAssetShown){
                this.linkAssetShown = true;
                this.showAsset(this.showAssetId)
            }
            // Deep link

            this.videoLoad( this.nowViewing );
            this.animationClass = 'fadeIn';
            this.showModal = true;
            this.showView = true;


            if ( this.nowViewing.asset_type_id === 1 && ( !this.dataObj.launch_with_splash || this.dataObj.launch_with_splash === 0 ) ) {
                this.init = false;
                this.loadPDF( this.nowViewing.asset_url )
            }

            if ( this.dataObj.launch_with_splash || this.dataObj.launch_with_splash === 1 ) {
                this.init = true;
            }
            WebFont.load({
                google: {
                    families: [ this.dataObj.style_guide_id.font ]
                }
            });
            setTimeout( () => {

            }, 2000 );
            document.addEventListener('pagesinit', () => {
                pdfjsViewer.currentScaleValue = 'page-width';
            });

            this.upNext = this.primarySeq.assets[ 1 ];
            this.currentIndex = 0;

            // Analytics
            this.trackData = this.initAnalytics();

            // BigPicture
            if(this.trackData){
                BigPicture.details((customerData) => {
                    this.customerData = customerData;
                    this.trackData?.initialEvents(this.analyticsData())
                    this.trackData?.addVistorEvent(this.analyticsData());
                    this.trackData?.addAssetViewEvent(this.analyticsData());
                    window.onbeforeunload = () => {
                        this.trackData?.onClose(this.analyticsData());
                    }
                });
            }

            this.nextInterval = setInterval(() => {
                if ( this.upNext && this.upNext.asset_type_id === 1 && this.nowViewing.asset_type_id === 1 && this.upNext.id !== this.primarySeq.assets[ 0 ].id && Math.round(this.progress * 100) >= 60 ) {
                    this.showContent( this.upNext, this.currentIndex, false );
                }
            }, 5000);
        },
        mounted(){
            // Drag Scroll
            // this.$refs.pdfViewer.style.cursor = 'grab';
            // this.$refs.pdfViewer.addEventListener('mousedown', this.mouseDownHandler);
            // this.$refs.pdfViewer.addEventListener('touchstart', this.touchStartHandler);
            // Drag Scroll
        },
        updated () {

        },
        destroyed() {
           this.pdfResponse && this.pdfResponse.destroy()
           clearInterval( this.nextInterval );
        },
        data () {
            return {
                nextInterval: null,
                showModal: false,
                animationClass: 'fadeOut',
                dataObj: this.$props.obj,
                loading: false,
                nowViewing: null,
                showView: false,
                playerOptions: {
                    // videojs options
                    autoplay: true,
                    muted: true,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [],
                    poster: null,
                },
                showPayWallCTA: true,
                upNext: null,
                fontObj: {},
                fontFile: null,
                currentIndex: 0,
                showNext: false,
                goToPrev: false, // Go to previous
                container: null,
                viewer: null,
                pdfViewer: null,
                currentPage: 0,
                pageCount: 0,
                max: false,
                // Zoom %
                zoomScale: 100,
                zoomAmount: 20,
                currentZoomScale: 100,
                zoomInLimit: 200,
                zoomOutLimit: 40,
                pdfScrollGap: 400,
                // Zoom
                contentWidth: window.innerWidth,
                contentHeight: window.innerHeight,
                totalPage: 0,
                progress: 0,
                pdfResponse: null,
                showLeftPanel: false,
                bgoverlay: false,
                // Analytics data
                trackData: null,
                customerData: {},
                init: true,
                // Analytics data
                secondsCounter:  5,
                showTimer: false,
                // Deep Link
                linkAssetShown: false,
                // Deep Link

                initialLoad: true,

                // Drag Scroll
                // dragPos: { top: 0, left: 0, x: 0, y: 0 },
                // dragScrollPrevElementHeight: 0,
                // dragScrollNextElementHeight: 0,
                // shouldScrollPrev: false,
                // shouldScrollNext: false,
                // dragScrollLimit: 100,
                // Drag Scroll
            };
        },
        methods: {
            CheckTimer ( next, index ) {
                this.countDownTimer(3)((count) => {
                    this.showTimer = true;
                    this.secondsCounter = count;
                }).then(() => {
                    this.showContent( next, index );
                    this.showTimer = false;
                })
            },
            handleScroll() {
                const progress = this.$refs.pdfViewer.scrollTop / (this.$refs.pdfViewer.scrollHeight - this.$refs.pdfViewer.clientHeight);
                if (progress > 1) {
                    this.progress = 1;
                } else if (progress < 0) {
                    this.progress = 0;
                } else {
                    this.progress = progress;
                }
                this.$refs.progressBar.style.width = `${ Math.round(this.progress * 100) }%`;

                /* Go to previous */
                // if(Math.round(this.progress * 100) === 0){
                //     if(this.goToPrev){
                //         this.goToPrev = false;
                //         let assetIndex = 0;
                //         this.primarySeq.assets.forEach(({now}, index) => {
                //             if(now) return assetIndex = index - 1;
                //         });
                //         if(assetIndex >= 0){
                //             this.upNext = this.primarySeq.assets[assetIndex + 1];
                //             this.currentIndex -= 2;
                //             this.CheckTimer( this.primarySeq.assets[assetIndex], this.currentIndex );
                //         }
                //     }
                // }
                // if ( Math.round(this.progress * 100) >= 15 ) {
                //     this.goToPrev = true;
                // }
                /* Go to previous */

                // if ( Math.round(this.progress * 100) >= 66 ) {
                //     this.showNext = true;
                // }

                if ( Math.round(this.progress * 100) === 100 ) {
                    if ( this.upNext ) {
                        this.showContent( this.upNext, this.currentIndex, false );
                    }
                }
            },
            loadPDF ( url ) {
                return new Promise( ( resolve, reject ) => {
                    if ( this.initialLoad ) {
                        $('canvas').remove();

                        // Drag Scroll
                        $('.content-indicator').remove();
                        // Drag Scroll

                        if ( this.$refs.progressBar ) {
                            this.$refs.progressBar.style.width = `0%`;
                        }
                        if ( this.$refs.pdfViewer ) {
                            this.$refs.pdfViewer.scrollTop = 0;
                        }
                        this.progress = 0;
                        this.pdfResponse && this.pdfResponse.destroy()
                        this.pdfResponse = null;
                        this.showNext = false;
                        pdfjsLib.disableRange = true;
                        pdfjsLib.disableStream = true;

                        this.loading = true;
                    }
                    this.$Progress.start();

                    pdfjsLib.getDocument(`${ process.env.VUE_APP_CORS_URL }${ url }`).promise.then((pdf) => {
                        this.pdfResponse = pdf;
                        this.pdfViewer = document.getElementById("pdfViewer");
                        // let scale = 1.2;
                        for(let page = 1; page <= pdf.numPages; page++) {
                            var canvas = document.createElement('canvas');
                            canvas.className ="pdf-page-canvas";
                            canvas.id = `pdf-${page}`;
                            canvas.style.height = 'auto';
                            canvas.style.width = '100%';
                            this.pdfViewer.appendChild(canvas);
                            this.renderPage( page, canvas, pdf, this.max ? 2 : 1.5 );
                        }
                        // PDF Scroll Gap
                        let cnv = document.createElement('canvas');
                        cnv.className ="pdf-page-canvas";
                        cnv.id = `pdf-${pdf.numPages + 1}${ Math.random() }`;
                        cnv.style.height = `${this.pdfScrollGap}px`;
                        cnv.style.width = '100%';
                        this.pdfViewer.appendChild(cnv);
                        const ctx = cnv.getContext('2d');
                        ctx.beginPath();
                        ctx.rect(0, 0, 0, 0);
                        ctx.fill();

                        // ctx.stroke();

                        resolve( true );

                        // Drag Scroll
                        // if(!this.isFirstAssetActive()){
                        //     let firstElement = document.createElement('section');
                        //     let logo = document.createElement('img');
                        //     let text = document.createElement('p');
                        //     logo.src = "https://securnyx360.s3.ap-south-1.amazonaws.com/lazy_logo.png"
                        //     text.textContent = "Swipe down for previous content"
                        //     firstElement.appendChild(logo)
                        //     firstElement.appendChild(text)
                        //     firstElement.className = "content-indicator"
                        //     this.pdfViewer.prepend(firstElement);
                        // }

                        // let lastElement = document.createElement('section');
                        // let logo = document.createElement('img');
                        // let text = document.createElement('p');
                        // logo.src = "https://securnyx360.s3.ap-south-1.amazonaws.com/lazy_logo.png"
                        // text.textContent = "Swipe up for next content"
                        // lastElement.appendChild(logo)
                        // lastElement.appendChild(text)
                        // lastElement.className = "content-indicator"
                        // this.pdfViewer.append(lastElement);
                        // Drag Scroll
                    });
                    // Zoom
                    this.zoomReset();
                } );

            },
            renderPage( pageNumber, canvas, thePdf, scale ) {
                // this.loading = true;
                this.$Progress.start();
                thePdf.getPage(pageNumber).then((page) => {
                    var viewport = page.getViewport({scale});
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    let ctx = canvas.getContext('2d');
                    page.render({canvasContext: ctx, viewport: viewport})
                    .promise.then(() => {
                        this.loading = false;
                        // this.$Progress.finish();
                        this.init = false;
                    });
                });

            },
            // Zoom
            zoomIn(){
                this.currentZoomScale += this.zoomAmount

                if(this.currentZoomScale > this.zoomInLimit) this.currentZoomScale = this.zoomInLimit;

                this.zoomPdf(this.currentZoomScale);
            },
            zoomOut(){
                this.currentZoomScale -= this.zoomAmount;

                if(this.currentZoomScale < this.zoomOutLimit) this.currentZoomScale = this.zoomOutLimit;

                this.zoomPdf(this.currentZoomScale);
            },
            zoomPdf(scale){
                const canvasList = this.pdfViewer.querySelectorAll("canvas");

                canvasList.forEach((canvas, index) => {
                    if(scale > 100 && scale < (100 + (this.zoomAmount * 2))){
                        canvas.style.scrollSnapAlign = "center";
                    }

                    if(index < canvasList.length) canvas.style.width = scale + "%";

                    if(scale == this.zoomOutLimit){
                         canvas.style.margin = "3px";
                         this.$refs.pdfViewer.style.overflowX = 'hidden';
                    }else{
                         canvas.style.removeProperty("margin");
                         this.$refs.pdfViewer.style.removeProperty("overflow-x");
                    }

                    setTimeout(() => {
                        canvas.style.removeProperty("scroll-snap-align")
                    }, 700)
                });

                const progress = this.$refs.pdfViewer.scrollTop / (this.$refs.pdfViewer.scrollHeight - this.$refs.pdfViewer.clientHeight);
                const scrollPercent = Math.round(progress * 100);

                if(scrollPercent == 100){
                    this.$refs.pdfViewer.scrollTop = this.$refs.pdfViewer.scrollTop - this.pdfScrollGap
                }
            },
            zoomReset(){
                this.currentZoomScale = this.zoomScale;
            },
            // Zoom
            closeModal () {
                if ( this.$props.depTyp !== 'embed' ) {
                    document.querySelector('html').style.overflow = 'auto';
                }
                clearInterval( this.nextInterval );
                this.animationClass = 'fadeOut';
                setTimeout( () => {
                    this.showModal = false;
                }, 450 );

                this.trackData?.addTotalTimeEvent(this.analyticsData());

                this.$emit("onClose");
            },
            async videoLoad ( lib ) {
                if ( lib.asset_type_id === 6 ) {
                    try {
                        this.loading = true;
                        this.$Progress.start();
                        const dataObj = await this.getFileTypeBlob( lib.asset_url );
                        this.playerOptions.sources = [{
                            type: dataObj,
                            src: lib.asset_url,
                        }];
                        this.playerOptions.poster = lib.cover_image_url;
                        this.$Progress.finish();
                        this.loading = false;
                    } catch (e) {
                        console.log(e);
                        this.$Progress.finish();
                        this.loading = false;
                    }
                } else {
                    return true;
                }
            },
            showContent (libNow, index, clicked = false) {

                // Go to previous
                this.goToPrev = false;
                this.init = false;
                this.currentIndex = index;

                this.$Progress.start();
                this.primarySeq.assets.map( ( lib, i ) => {
                    lib.now = lib.id === libNow.id;
                    if ( lib.id === libNow.id ) {
                        if ( typeof( this.primarySeq.assets[ i + 1 ] ) != "undefined" ) {
                            this.upNext = this.primarySeq.assets[ i + 1 ];
                        } else {
                            this.upNext = this.primarySeq.assets[ 0 ];
                        }
                    }
                    return lib;
                } );

                this.videoLoad( libNow );
                this.nowViewing = { ...libNow };
                this.nowViewing.now = true;

                this.initialLoad = false;
                if ( clicked ) {
                    this.initialLoad = true;
                }
                if ( this.nowViewing.id === this.primarySeq.assets[ 0 ].id ) {
                    this.initialLoad = true;
                }

                if ( this.nowViewing.asset_type_id === 1 ) {
                    if ( this.initialLoad ) {
                        $('canvas').remove();
                        if ( this.$refs.progressBar ) {
                            this.$refs.progressBar.style.width = `0%`;
                        }
                        if ( this.$refs.pdfViewer ) {
                            this.$refs.pdfViewer.scrollTop = 0;
                        }
                        this.progress = 0;
                        this.pdfResponse && this.pdfResponse.destroy()
                        this.pdfResponse = null;
                        this.showNext = false;
                        pdfjsLib.disableRange = true;
                        pdfjsLib.disableStream = true;
                    }
                    setTimeout( () => {
                        this.loadPDF( libNow.asset_url ).then( ( response ) => {
                            if ( response ) {
                                this.$Progress.finish();
                            }
                        } );
                    }, 300 );
                }

                if ( libNow.asset_type_id !== 6  ) {
                    setTimeout( () => {
                        this.$Progress.finish();
                    }, 450 );
                }

                this.trackData?.addAssetViewEvent(this.analyticsData());
            },
            // Analytics Functions
            initAnalytics(){
              return new AnalyticsTracking({
                    platform_customer_id: this.dataObj.platform_customer_id,
              });
            },
            analyticsData() {
                return {
                    experience:{
                        id: parseInt(this.obj.id),
                        name: this.obj.experience_name,
                        experience_type: this.obj.experience_type,
                        delivery_type: this.obj.delivery_type || "share"
                    },
                    asset: {
                        id: parseInt(this.nowViewing.id),
                        name: this.nowViewing.asset_friendly_name,
                    },
                    sequence: {
                        id: parseInt(this.primarySeq.id),
                        name: this.primarySeq.sequence_name,
                    },
                    customer: this.customerData
                }
            },
            // Analytics Functions
            // Deep Link
            showSequence(sequenceId = 0){
                if(!sequenceId) return

                const primarySequence = this.dataObj.primary_sequence;
                this.dataObj.sequences = [...this.dataObj.sequences, primarySequence]
                const currentSequence = this.dataObj.sequences.find(({id}) => id == sequenceId);
                this.dataObj.primary_sequence = currentSequence
                this.dataObj.sequences = this.dataObj.sequences.filter(({id}) => id != currentSequence.id);
            },
            showAsset(assetId){
                if(!assetId) return;

                let assetIndex = this.primarySeq.assets.findIndex(({id}) => id == assetId);
                assetIndex = assetIndex == -1 ? 0 : assetIndex;
                this.primarySeq.assets[ assetIndex ].now = true;
                this.nowViewing = this.primarySeq.assets[ assetIndex ];
                this.videoLoad( this.primarySeq.assets[assetIndex] );
            },
            // Deep Link

            // Drag Scroll
            mouseDownHandler(e) {
                this.$refs.pdfViewer.style.cursor = 'grabbing';
                this.$refs.pdfViewer.style.userSelect = 'none';

                this.dragPos = {
                    left: this.$refs.pdfViewer.scrollLeft,
                    top: this.$refs.pdfViewer.scrollTop,
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };

                this.$refs.pdfViewer.addEventListener('mousemove', this.mouseMoveHandler);
                this.$refs.pdfViewer.addEventListener('mouseup', this.mouseUpHandler);
                this.$refs.pdfViewer.addEventListener('mouseleave', this.mouseLeaveHandler);
            },
            mouseMoveHandler(e) {
                // How far the mouse has been moved
                const dx = e.clientX - this.dragPos.x;
                const dy = e.clientY - this.dragPos.y;

                // Scroll the element
                this.$refs.pdfViewer.scrollTop = this.dragPos.top - dy;
                this.$refs.pdfViewer.scrollLeft = this.dragPos.left - dx;

                this.handleSwipe(dx, dy);
            },
            mouseUpHandler() {
                this.handleSwipeRelease();
            },
            mouseLeaveHandler() {

                this.dragScrollPrevElementHeight = 0;
                this.$refs.pdfViewer.firstElementChild.style.marginBottom = `${this.dragScrollPrevElementHeight}px`;

                this.dragScrollNextElementHeight = 0
                this.$refs.pdfViewer.lastElementChild.style.marginTop = `${this.dragScrollNextElementHeight}px`;

                this.$refs.pdfViewer.style.cursor = 'grab';
                this.$refs.pdfViewer.style.removeProperty('user-select');

                this.$refs.pdfViewer.removeEventListener('mousemove', this.mouseMoveHandler);
                this.$refs.pdfViewer.removeEventListener('mouseup', this.mouseUpHandler);
            },
            touchStartHandler(e) {
                e.preventDefault()

                this.dragPos = {
                    left: this.$refs.pdfViewer.scrollLeft,
                    top: this.$refs.pdfViewer.scrollTop,
                    // Get the current mouse position
                    x: e.targetTouches[0].clientX,
                    y: e.targetTouches[0].clientY,
                };

                this.$refs.pdfViewer.addEventListener('touchmove', this.touchMoveHandler);
                this.$refs.pdfViewer.addEventListener('touchend', this.touchEndHandler);
            },
            touchMoveHandler(e) {
                e.preventDefault()

                // How far the mouse has been moved
                const dx = e.targetTouches[0].clientX - this.dragPos.x;
                const dy = e.targetTouches[0].clientY - this.dragPos.y;

                // Scroll the element
                this.$refs.pdfViewer.scrollTop = this.dragPos.top - dy;
                this.$refs.pdfViewer.scrollLeft = this.dragPos.left - dx;

                this.handleSwipe(dx, dy);
            },
            touchEndHandler() {
                this.handleSwipeRelease();
            },
            handleSwipe(dx, dy){
                let maxheight = (this.$refs.pdfViewer.scrollHeight - this.$refs.pdfViewer.clientHeight)

                if(maxheight == 0) maxheight = 1;

                let progress = this.$refs.pdfViewer.scrollTop / maxheight;

                let isNegative = (progress == 0)

                let scrollPercent = Math.round(progress * 100);
                let scrollNextPercent = scrollPercent;

                if(isNegative) {
                    scrollNextPercent = 100
                }

                // Prev Asset
                const isFirstAsset = this.isFirstAssetActive()
                if(!isFirstAsset && scrollPercent == 0 && dy > 0){
                    let value = dy - 100
                    if(value < 0) value = 0
                    this.dragScrollPrevElementHeight = value;

                    if(this.dragScrollPrevElementHeight > this.dragScrollLimit){
                        this.dragScrollPrevElementHeight = this.dragScrollLimit
                    }

                    this.$refs.pdfViewer.firstElementChild.style.marginBottom = `${this.dragScrollPrevElementHeight}px`;
                }

                // Next Asset
                if(scrollNextPercent == 100 && dy < 0){
                    let value = Math.abs(dy) - 100
                    if(value < 0) value = 0
                    this.dragScrollNextElementHeight = value;

                    if(this.dragScrollNextElementHeight > this.dragScrollLimit){
                        this.dragScrollNextElementHeight = this.dragScrollLimit
                    }

                    this.$refs.pdfViewer.lastElementChild.style.marginTop = `${this.dragScrollNextElementHeight}px`;

                    if(this.dragScrollNextElementHeight > 0){
                        this.$refs.pdfViewer.scrollTop = this.$refs.pdfViewer.scrollHeight
                    }
                }
            },
            handleSwipeRelease(){
                let isPrevScrolled = false;

                // Prev Asset
                if(this.dragScrollPrevElementHeight < this.dragScrollLimit){
                    this.dragScrollPrevElementHeight = 0
                    this.$refs.pdfViewer.firstElementChild.style.marginBottom = `${this.dragScrollPrevElementHeight}px`;
                }else{
                    let assetIndex = 0;
                    this.primarySeq.assets.forEach(({now}, index) => {
                        if(now) return assetIndex = index - 1;
                    });
                    if(assetIndex >= 0){
                        this.upNext = this.primarySeq.assets[assetIndex + 1];
                        this.currentIndex -= 2;
                        this.showContent( this.primarySeq.assets[assetIndex], this.currentIndex );
                        isPrevScrolled = true;
                    }
                }

                // Next Asset
                if(!isPrevScrolled && this.dragScrollNextElementHeight < this.dragScrollLimit){
                     this.dragScrollNextElementHeight = 0
                     this.$refs.pdfViewer.lastElementChild.style.marginTop = `${this.dragScrollNextElementHeight}px`;

                }else if(this.dragScrollNextElementHeight == this.dragScrollLimit){
                    this.showContent(this.upNext, this.currentIndex)
                }

                this.dragScrollNextElementHeight = 0;
                this.dragScrollPrevElementHeight = 0;

                this.$refs.pdfViewer.style.cursor = 'grab';
                this.$refs.pdfViewer.style.removeProperty('user-select');

                this.$refs.pdfViewer.removeEventListener('mousemove', this.mouseMoveHandler);
                this.$refs.pdfViewer.removeEventListener('mouseup', this.mouseUpHandler);
                this.$refs.pdfViewer.removeEventListener('touchmove', this.mouseMoveHandler);
                this.$refs.pdfViewer.removeEventListener('touchend', this.mouseUpHandler);
            },
            isFirstAssetActive(){
                return this.primarySeq.assets[0].now === true;
            }
            // Drag Scroll
        },
        computed: {
            sequenceChange () {
                if ( this.dataObj.primary_sequence ) {
                    if ( this.dataObj.primary_sequence.assets.length > 0 ) {
                        this.primarySeq = this.dataObj.primary_sequence;
                        this.primarySeq.assets = this.primarySeq.assets.map( ( lib ) => {
                            lib.now = false;
                            return lib;
                        });

                        if(!this.showAssetId && !this.linkAssetShown){ // Deep Link
                            this.primarySeq.assets[ 0 ].now = true;
                            this.nowViewing = this.primarySeq.assets[ 0 ];
                            this.videoLoad( this.primarySeq.assets[ 0 ] );
                        }

                        // this.primarySeq.assets[ 0 ].now = true;
                        // this.nowViewing = this.primarySeq.assets[ 0 ];
                        // this.videoLoad( this.primarySeq.assets[ 0 ] );
                        // this.upNext = this.primarySeq.assets[ 1 ];
                        // this.showNext = true;
                    }
                }
            },
        },
    }
</script>

<style>
    /* Drag Scroll */
    #pdfViewer .content-indicator{
         display: flex;
         justify-content: center;
         align-items: center;
         padding-top: 10px;
         padding-bottom: 15px;
    }
    #pdfViewer .content-indicator img{
         width: 30px;
         height: 30px;
    }
    #pdfViewer .content-indicator p{
        padding-left: 10px;
        margin-top: auto;
        margin-bottom: auto;
        font-size: 0.9em;
    }
    /* Drag Scroll */
</style>
